module.exports = __webpack_public_path__ + "static/img/Simulations 4 - Manoeuvring strategies.7e3568d.png";